import { SET_SELECTED_ORIGIN_GHA_ID } from '../actions/actionTypes';

const initialState: number = -1;

export const originGhaReducer = (state: number = initialState, action: any) => {
  switch (action.type) {
    case SET_SELECTED_ORIGIN_GHA_ID:
      return action.data;
    default:
     return state;
  };
};